import { makeAutoObservable } from "mobx";
import { getFormattedDate } from "../../helpers";

class MainStore {
  appLoaded = false;
  config = null;
  token = null;
  floors = [];
  subCategories = [];
  defaultFloor = null;
  showNavigateLoading = false;
  selectedStartShape = null;
  selectedStartPoi = null;
  selectedDestinationShape = null;
  selectedDestinationPoi = null;
  appLogo = null;
  appBackground = null;
  homeLogo = null;
  homeHeaderLabel = null;
  homeMenuHighlightsLabel = null;
  homeMenuHighlightsLogo = null;
  homeMenuGeneralEnquiriesLabel = null;
  homeMenuGeneralEnquiriesLogo = null;
  homeMenuWayfinderLabel = null;
  homeMenuWayfinderLogo = null;
  homeMenuResourcesLabel = null;
  homeMenuResourcesLogo = null;

  popupMessage = null;
  popupFormHeader = null;
  popupFormHeaderRatingLabel = null;
  popupFormHeaderCommentLabel = null;
  popupFormHeaderThankouMsg = null;

  smileFeedbackIcon = null;

  weatherLink = "https://www.weather.gov.sg";

  isChatbotStart = false;

  chatHistory = [];

  customerChatHistory = [];

  isBotTyping = false;

  latestMessageSentByUser = {};
  chatHistoryWithCS = [];

  formFeedbackTitle = null;
  formFeedbackFieldName = null;
  formFeedbackThankYouMsg = null;
  formFeedbackThankYouImg = null;

  canAccessCustomerServiceChat = false;

  constructor() {
    makeAutoObservable(this);
  }

  setAppLoaded(appLoaded) {
    this.appLoaded = appLoaded;
  }

  setConfig(config) {
    this.config = config;
  }

  setToken(token) {
    this.token = token;
  }

  setFloors(floors) {
    this.floors = floors;
  }

  setSubCategories(subCategories) {
    this.subCategories = subCategories;
  }

  setDefaultFloor(defaultFloor) {
    this.defaultFloor = defaultFloor;
  }

  setShowNavigateLoading(showNavigateLoading) {
    this.showNavigateLoading = showNavigateLoading;
  }

  setSelectedStartShape(selectedStartShape) {
    this.selectedStartShape = selectedStartShape;
  }

  setSelectedStartPoi(selectedStartPoi) {
    this.selectedStartPoi = selectedStartPoi;
  }

  setSelectedDestinationShape(selectedDestinationShape) {
    this.selectedDestinationShape = selectedDestinationShape;
  }

  setSelectedDestinationPoi(selectedDestinationPoi) {
    this.selectedDestinationPoi = selectedDestinationPoi;
  }

  setAppLogo(logo) {
    this.appLogo = logo;
  }

  setAppBackground(background) {
    this.appBackground = background;
  }

  setHomeAttr(logo, headerLabel) {
    this.homeLogo = logo;
    this.homeHeaderLabel = headerLabel;
  }
  setHomeMenuHighlightAttr(logo, label) {
    this.homeMenuHighlightsLogo = logo;
    this.homeMenuHighlightsLabel = label;
  }
  setHomeMenuGeneralEnquiriesAttr(logo, label) {
    this.homeMenuGeneralEnquiriesLogo = logo;
    this.homeMenuGeneralEnquiriesLabel = label;
  }
  setHomeMenuWayfinderAttr(logo, label) {
    this.homeMenuWayfinderLogo = logo;
    this.homeMenuWayfinderLabel = label;
  }
  setHomeMenuResourcesAttr(logo, label) {
    this.homeMenuResourcesLogo = logo;
    this.homeMenuResourcesLabel = label;
  }
  setPopupMessage(message) {
    this.popupMessage = message;
  }
  setPopupFormHeader(message) {
    this.popupFormHeader = message;
  }
  setPopupFormHeaderRatingLabel(message) {
    this.popupFormHeaderRatingLabel = message;
  }
  setPopupFormHeaderCommentLabel(message) {
    this.popupFormHeaderCommentLabel = message;
  }
  setPopupFormHeaderThankouMsg(message) {
    this.popupFormHeaderThankouMsg = message;
  }

  setChatHistory(chat) {
    const chatHistoryTemp = this.chatHistory;
    chatHistoryTemp.push(chat);
    this.chatHistory = chatHistoryTemp;
  }

  setCustomerChatHistory(chat) {
    const chatHistoryTemp = this.customerChatHistory;
    chatHistoryTemp.push(chat);
    this.customerChatHistory = chatHistoryTemp;
  }

  setIsBotTyping(value) {
    this.isBotTyping = value;
  }

  setIsChatbotStart(value) {
    this.isChatbotStart = value;
  }

  setWeatherLink(value) {
    this.weatherLink = value;
  }

  setSmileFeedbackIcon(value) {
    this.smileFeedbackIcon = value;
  }

  setLatestMessageSentByUser(value) {
    this.latestMessageSentByUser = value;
  }

  setChatHistoryWithCS(value) {
    this.chatHistoryWithCS = value;
  }

  setFormFeedbackTitle(value) {
    this.formFeedbackTitle = value;
  }

  setFormFeedbackFieldName(value) {
    this.formFeedbackFieldName = value;
  }

  setFormFeedbackThankYouMsg(value) {
    this.formFeedbackThankYouMsg = value;
  }

  setFormFeedbackThankYouImg(value) {
    this.formFeedbackThankYouImg = value;
  }

  setCanAccessCustomerServiceChat(value) {
    this.canAccessCustomerServiceChat = value;
  }
}

export default MainStore;
